// @flow
import React from 'react'
import { LockUnlockIcon } from '../../Distributions/components/permissions'
import styles from './styles.css'

type Props = {
  title?: string,
  status?: string,
  statusLabel?: string,
  isLoading?: boolean,
  id?: string | number,
  lockedForEdit?: boolean,
}

const Header = ({ title = 'DEPOSIT', status = 'Receive', statusLabel = 'Current Step:', isLoading = false, id, lockedForEdit = false }: Props) => {
  const formatStatus = (status) => {
    return status.replace(/_/g, ' ').toUpperCase()
  }

  return (
    <div className={styles.headerContainer}>
      <div className={styles.titleSection}>
        <div className={styles.title}>{title}</div>
      </div>
      <div className={styles.statusSection}>
        <div className={styles.statusIcon}>$ </div>
        <div className={styles.statusContent}>
          <div className={styles.statusLabel}>{statusLabel}</div>
          <div className={styles.statusValue}>{isLoading ? 'Loading...' : formatStatus(status)}</div>
        </div>

        {id && (
          <div className={styles.templateId}>
            ID: <span>{id}</span>
          </div>
        )}

        <div className={styles.lockUnlockIcon}>
          <LockUnlockIcon lockedForEdit={lockedForEdit} />
        </div>
      </div>
    </div>
  )
}

export default Header
